import { SuggestionMenuController } from '@blocknote/react';

import type { SlashMenuItem } from './types';

interface BlockNoteSlashMenuProps {
  getItems?: (query: string) => Promise<SlashMenuItem[]>;
}

/**
 * Connects caller-provided slash menu items to BlockNote's suggestion menu.
 */
export function BlockNoteSlashMenu({ getItems }: BlockNoteSlashMenuProps) {
  if (!getItems) {
    return null;
  }

  return (
    <SuggestionMenuController
      triggerCharacter="/"
      getItems={getItems}
      onItemClick={(item) => item.onItemClick()}
      suggestionMenuComponent={undefined as never}
    />
  );
}
